export const translations = {
  en: {
    nav: {
      home: "Home",
      philosophy: "Philosophy",
      book: "The Book",
      guestbook: "Tango Echoes",
      contact: "Private Classes",
      impressum: "Impressum",
      datenschutz: "Privacy"
    },
    hero: {
      title: "Regina & Walter",
      subtitle: "Tango Argentino",
      tagline: "Teaching Connection, Musicality, and Technique.",
      description: "We dance and teach together, guiding our students to listen to the music and connect deeply with their partners. Discover the authentic elegance of local milongas in Buenos Aires.",
      ctaBook: "The Book",
      ctaContact: "Private Classes"
    },
    philosophy: {
      title: "Our Philosophy",
      subtitle: "The Three Pillars of Argentine Tango",
      intro: "Walter and Regina teach Argentine Tango not as a series of steps, but as an intimate, musical conversation between two souls.",
      connectionTitle: "Connection",
      connectionText: "The heart of Tango. We teach how to establish a silent conversation, a harmonious lead and follow where partners move as a single, breathing entity.",
      musicalityTitle: "Musicality",
      musicalityText: "Listen to the music, not just the rhythm. We guide you to feel the instrumentation, the phrasing, and to dance with the soul of the orchestra.",
      techniqueTitle: "Technique",
      techniqueText: "The foundation of freedom. Precise axis control, posturing, and pivoting that enable fluid movement, allowing you to dance comfortably and elegantly.",
      dialogueTitle: "Deepen the Dialogue",
      dialogueText: "Tango is not a spectator sport, nor is it a rigid stage presentation. It is a shared feeling, an embrace, a quiet conversation that happens in close embrace. Walter and Regina empower you with the tools to listen to your partner and interpret the music naturally."
    },
    book: {
      title: "Our Travel Guide",
      subtitle: "Buenos Aires für Tango Reisende - ein Leitfaden",
      isbn: "ISBN 978-3819246197",
      description1: "We frequently travel to Buenos Aires, Argentina, to dance in the local milongas and study under the most respected masters. Our passion materialized in this practical guidebook.",
      description2: "Written specifically for Tango dancers, this guide prepares you to navigate the unique social codes (códigos) and succeed in the authentic milongas of Buenos Aires.",
      buyBtn: "View on Amazon",
      inquireBtn: "Inquire via Email",
      availability: "The book is available in bookstores and online.",
      highlight1Title: "Authentic Codes (Códigos)",
      highlight1Text: "Learn the unspoken rules of the milongas (Cabeceo, Ronda, and dance floor etiquette) so you can dance like a local.",
      highlight2Title: "Insider Recommendations",
      highlight2Text: "Curated list of authentic milongas, safe neighborhood travel tips, and how to create a beautiful tango experience in Buenos Aires.",
      reviewLabel: "Book review by the German tango magazine 'Tango Danza':",
      reviewText: "Regina Prachner and Walter Unterberger have not written a classic travel guide. Their \u201Cguide\u201D is a very personal travel account, fed by the experiences of their numerous stays in Buenos Aires.\nIt aims to help plan and prepare a trip to the Río de la Plata in the best possible way. The heart of the book, however, is devoted to visiting a milonga. A milonga in Buenos Aires is completely orchestrated. Reception, seating, códigos and dance behaviour \u2013 if you ignore the rules, no, the laws, the evening quickly turns into a disaster. ...\nHere Prachner and Unterberger give valuable tips: talk to your own teachers to get recommendations. Visit prácticas before the milongas to meet others, be it other tango tourists or Porteños. Best of all, Prachner and Unterberger recommend, go to a milonga as a group. Then you will get to dance for sure and experience the magic of tango up close. A recommendable book. A book that grounds you.",
      reviewSource: "Review by Jürgen Dürmeier in Tangodanza 104 \u2013 4.2025",
      contactNote: "We are happy to discuss your plans regarding a trip to Buenos Aires with you. Get in touch with us, preferably by email."
    },
    privateClasses: {
      title: "Private Classes",
      subtitle: "Tailored to Your Tango Journey",
      description1: "Whether you want to refine your technique, deepen your connection, or master musicality, we offer personalized private lessons tailored entirely to your personal goals.",
      description2: "All private sessions are taught together by both Regina and Walter, providing you with dual perspectives on leading, following, and partner dynamics.",
      cta: "Book Private Class via Email",
      ctaSub: "Inquiries at office@entreamigos.at",
      perkScheduling: "Flexible scheduling",
      perkLocation: "Vienna studio or worldwide",
      perkInstructors: "Two instructors / Walter & Regina",
      perkEmail: "Direct email contact",
      cardTitle: "Start Your Lesson",
      cardText: "Send us an email outlining your tango level, partners, and preferred dates. We will design a customized curriculum for you."
    },
    guestbook: {
      title: "Tango Echoes",
      subtitle: "Voluntary student guestbook. Share your experiences & memories with us.",
      labelName: "Your Name",
      labelMessage: "Your Message / Tango Memory",
      placeholderName: "e.g., Diego & Anna",
      placeholderMessage: "Write about your experience in our private lessons or your tango journey...",
      submitBtn: "Post to Guestbook",
      submitting: "Posting...",
      noEntries: "No entries yet. Be the first to share a tango memory!",
      privacyNotice: "Zero Cookies. Zero Tracking. Submitting this form is completely voluntary and stores your name and message publicly. We do not use cookies or track your data."
    },
    footer: {
      tagline: "Elegance. Musicality. Connection.",
      allRights: "All rights reserved.",
      noCookies: "No cookies. No user tracking. We value your absolute privacy."
    },
    social: {
      title: "Stay Connected",
      youtube: "Watch our videos on YouTube",
      instagram: "Follow us on Instagram"
    },
    impressum: {
      title: "Impressum",
      mediaOwner: "Media Owner & Operator",
      names: "Regina & Walter",
      address: "Vienna, Austria",
      email: "office@entreamigos.at",
      hostTitle: "Website Hosting",
      hostDetails: "Hosted by easyname.com (easyname GmbH, Vienna, Austria)",
      privacyTitle: "Privacy Policy (Datenschutzerklärung)",
      privacyText: "This website does not use cookies, local storage, or any tracking mechanisms. We do not collect, process, or store any personal information of the viewer, except when you voluntarily submit a post in our guestbook. Private class inquiries are processed directly via your native email client (mailto) and are not stored on this website's server.",
      close: "Close"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      philosophy: "Philosophie",
      book: "Das Buch",
      guestbook: "Tango-Echos",
      contact: "Privatstunden",
      impressum: "Impressum",
      datenschutz: "Datenschutz"
    },
    hero: {
      title: "Regina & Walter",
      subtitle: "Tango Argentino",
      tagline: "Unterricht für Verbindung, Musikalität und Technik.",
      description: "Wir tanzen und unterrichten gemeinsam. Wir leiten unsere Schüler an, auf die Musik zu hören und sich tief mit ihren Partnern zu verbinden. Erleben Sie die authentische Eleganz der lokalen Milongas in Buenos Aires.",
      ctaBook: "Das Buch",
      ctaContact: "Privatstunden"
    },
    philosophy: {
      title: "Unsere Philosophie",
      subtitle: "Die drei Säulen des argentinischen Tangos",
      intro: "Walter und Regina unterrichten argentinischen Tango nicht als eine Abfolge von Schritten, sondern als ein intimes, musikalisches Gespräch zwischen zwei Seelen.",
      connectionTitle: "Verbindung",
      connectionText: "Das Herz des Tangos. Wir lehren, eine lautlose Konversation aufzubauen - ein harmonisches Führen und Folgen, bei dem sich die Partner als eine atmende Einheit bewegen.",
      musicalityTitle: "Musikalität",
      musicalityText: "Hören Sie die Musik, nicht nur den Rhythmus. Wir leiten Sie an, die Instrumentierung und Phrasierung zu spüren und mit der Seele des Orchesters zu tanzen.",
      techniqueTitle: "Technik",
      techniqueText: "Das Fundament der Freiheit. Präzise Achsenkontrolle, Haltung und Drehungen, die fließende Bewegungen ermöglichen, damit Sie sich bequem und elegant bewegen können.",
      dialogueTitle: "Den Dialog vertiefen",
      dialogueText: "Tango ist kein Zuschauersport und auch keine starre Bühnendarbietung. Es ist ein gemeinsames Gefühl, eine Umarmung, ein stilles Gespräch in enger Umarmung. Walter und Regina geben Ihnen die Werkzeuge an die Hand, um Ihrem Partner zuzuhören und die Musik natürlich zu interpretieren."
    },
    book: {
      title: "Unser Reiseführer",
      subtitle: "Buenos Aires für Tango Reisende - ein Leitfaden",
      isbn: "ISBN 978-3819246197",
      description1: "Wir reisen regelmäßig nach Buenos Aires, Argentinien, um in den lokalen Milongas zu tanzen und bei den angesehensten Meistern zu lernen. Unsere Leidenschaft floss in diesen praktischen Leitfaden ein.",
      description2: "Speziell für Tango-Tänzende geschrieben, bereitet Sie dieser Ratgeber darauf vor, die einzigartigen sozialen Codes (Códigos) zu verstehen und in den authentischen Milongas von Buenos Aires erfolgreich zu sein.",
      buyBtn: "Auf Amazon ansehen",
      inquireBtn: "Per E-Mail anfragen",
      availability: "Das Buch ist im Fachhandel und im Online Handel erhältlich.",
      highlight1Title: "Authentische Codes (Códigos)",
      highlight1Text: "Lernen Sie die ungeschriebenen Regeln der Milongas (Cabeceo, Ronda und Tanzflächen-Etikette) kennen, um wie ein Einheimischer zu tanzen.",
      highlight2Title: "Insider-Empfehlungen",
      highlight2Text: "Ausgewählte Liste authentischer Milongas, sichere Reisetipps für die Stadtviertel und wie Sie einen erfüllten Tango Urlaub erleben.",
      reviewLabel: "Buch-Rezension der deutschen Tango-Zeitschrift 'Tango Danza':",
      reviewText: "Regina Prachner und Walter Unterberger haben keinen klassischen Reiseführer geschrieben. Ihr \u201ELeitfaden\u201C ist ein sehr persönlicher Reisebericht, gespeist aus den Erfahrungen ihrer zahlreichen Aufenthalte in Buenos Aires.\nEr soll helfen, eine Reise an den Río de la Plata optimal zu planen und vorzubereiten. Das Herzstück des Buches aber widmet sich dem Besuch einer Milonga. Eine Milonga in Buenos Aires ist komplett durchorchestriert. Empfang, Platzzuteilung, Códigos und Tanzverhalten \u2013 sollte man die Regeln, nein, Gesetze, ignorieren, wird der Abend sehr schnell zum Desaster. ...\nHier geben Prachner und Unterberger wertvolle Tipps: mit den eigenen Lehrern sprechen, um sich Empfehlungen geben zu lassen. Prácticas vor den Milongas besuchen, um andere kennenzulernen, seien es andere Tango-Touristen oder Porteños. Am besten, das empfehlen Prachner und Unterberger, geht man in einer Gruppe auf eine Milonga. Dann komme man auf jeden Fall zum Tanzen und könne den Zauber des Tango hautnah erleben. Ein empfehlenswertes Buch. Ein Buch, das erdet.",
      reviewSource: "Rezension von Jürgen Dürmeier in Tangodanza 104 \u2013 4.2025",
      contactNote: "Wir diskutieren gerne Ihre Anliegen bezüglich einer Buenos Aires mit Ihnen. Kontaktieren Sie uns, am besten per E-Mail."
    },
    privateClasses: {
      title: "Privatstunden",
      subtitle: "Individuell für Ihren Tango-Weg",
      description1: "Egal, ob Sie Ihre Technik verfeinern, Ihre Verbindung vertiefen oder Ihre Musikalität meistern möchten – wir bieten maßgeschneiderte Privatstunden, die sich ganz nach Ihren persönlichen Zielen richten.",
      description2: "Alle Privatstunden werden von Walter und Regina gemeinsam unterrichtet. So erhalten Sie wertvolle Perspektiven auf das Führen und Folgen sowie die Dynamik als Paar.",
      cta: "Privatstunde per E-Mail anfragen",
      ctaSub: "Anfragen an office@entreamigos.at",
      perkScheduling: "Flexible Terminplanung",
      perkLocation: "Studio in Wien oder weltweit",
      perkInstructors: "Zwei Lehrende / Walter & Regina",
      perkEmail: "Direkter E-Mail-Kontakt",
      cardTitle: "Beginnen Sie Ihre Stunde",
      cardText: "Schreiben Sie uns eine E-Mail mit Ihrem Tango-Level, Ihren Partnern und Ihren Wunschterminen. Wir gestalten ein individuelles Programm für Sie."
    },
    guestbook: {
      title: "Tango-Echos",
      subtitle: "Freiwilliges Gästebuch für Schüler. Teilen Sie Ihre Erfahrungen & Erinnerungen mit uns.",
      labelName: "Ihr Name",
      labelMessage: "Ihre Nachricht / Tango-Erinnerung",
      placeholderName: "z.B. Diego & Anna",
      placeholderMessage: "Schreiben Sie über Ihre Erfahrungen in unseren Privatstunden oder Ihre Tango-Reise...",
      submitBtn: "Ins Gästebuch eintragen",
      submitting: "Wird gepostet...",
      noEntries: "Noch keine Einträge. Teilen Sie als Erster eine Tango-Erinnerung!",
      privacyNotice: "Keine Cookies. Kein Tracking. Das Absenden dieses Formulars ist absolut freiwillig und speichert Ihren Namen und Ihre Nachricht öffentlich. Wir verwenden keine Cookies und verfolgen keine Ihrer Daten."
    },
    footer: {
      tagline: "Eleganz. Musikalität. Verbindung.",
      allRights: "Alle Rechte vorbehalten.",
      noCookies: "Keine Cookies. Kein Benutzer-Tracking. Wir achten Ihre absolute Privatsphäre."
    },
    social: {
      title: "Bleiben Sie in Verbindung",
      youtube: "Schauen Sie sich unsere Videos auf YouTube an",
      instagram: "Folgen Sie uns auf Instagram"
    },
    impressum: {
      title: "Impressum",
      mediaOwner: "Medieninhaber & Betreiber",
      names: "Walter & Regina",
      address: "Wien, Österreich",
      email: "office@entreamigos.at",
      hostTitle: "Website-Hosting",
      hostDetails: "Gehostet von easyname.com (easyname GmbH, Wien, Österreich)",
      privacyTitle: "Datenschutzerklärung",
      privacyText: "Diese Website verwendet keine Cookies, keinen lokalen Speicher oder sonstige Tracking-Mechanismen. Wir erfassen, verarbeiten oder speichern keine personenbezogenen Daten des Betrachters, außer wenn Sie freiwillig einen Beitrag in unserem Gästebuch veröffentlichen. Privatstunden-Anfragen werden direkt über Ihren eigenen E-Mail-Client (mailto) abgewickelt und nicht auf dem Server dieser Website gespeichert.",
      close: "Schließen"
    }
  }
};
